import React, { useEffect, useState } from "react";
import axios from "axios";

Policyapprove1.propTypes = {};

function Policyapprove1(props) {
  
  const [Uterms, setUterms] = useState('');

  useEffect(() => {
    axios.get('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getUterms')
        .then(response => setUterms(response.data.Uterms))
        .catch(error => console.error('Error fetching Uterms:', error));
}, []);

  return (
    <>
    
        <section className="testimonials-category-section" style={{ paddingTop: "30px", paddingBottom:"30px" }}>
           <div className="tf-container">
             <div className="row">
              
     
               <div className="col-md-10"  style={{margin:"auto", padding:"auto"}}>
                 <div className="row">
               <div
       style={{ marginBottom: "5px", marginTop: "10px" }}
       dangerouslySetInnerHTML={{ __html: Uterms}}
     ></div>
                 </div>
               </div>
             </div>
           </div>
         </section>
      
       
    </>
  );
}

export default Policyapprove1;
